import { useState } from "react";

import SwatchesPicker from "../Shared/SwatchesPicker";
import Box from "@mui/material/Box";
import Slider from "@mui/material/Slider";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import Popover from "@mui/material/Popover";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const expand_ = (theme) => ({
  transform: "rotate(0deg)",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
});

const expandOpen_ = (theme) => ({
  transform: "rotate(180deg)",
});

const settingContainer_ = (theme) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-evenly",
  width: "100%",
  alignItems: "center",
  minHeight: 50,
  margin: "5px",
});

const settingIcon_ = (theme) => ({
  width: "10%",
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
});

const settingLabel_ = (theme) => ({
  width: "35%",
  fontSize: "14px",
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
});

const settingDisabled_ = (theme) => ({
  opacity: "50%",
});

const settingController_ = (theme) => ({
  width: "45%",
  marginRight: "10px",
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
});

const error_ = (theme) => ({
  color: theme.palette.error.main,
});

export const Setting = ({
  label,
  labelIcon,
  controller,
  active = true,
  error = false,
}) => {
  return (
    <Box sx={settingContainer_}>
      <Box sx={[settingIcon_, !active && settingDisabled_, error && error_]}>
        {labelIcon}
      </Box>
      <Box sx={[settingLabel_, !active && settingDisabled_, error && error_]}>
        {label}
      </Box>
      <Box sx={settingController_}>{controller}</Box>
    </Box>
  );
};

export const SettingSlider = (props) => {
  const {
    handleNewValue,
    min,
    max,
    step,
    label,
    active = true,
    labelIcon,
    value,
    track,
    valueLabelDisplay,
  } = props;

  const handleChange = (_event, newValue) => {
    handleNewValue(newValue);
  };

  return (
    <Setting
      label={label}
      active={active}
      labelIcon={labelIcon}
      controller={
        <Slider
          aria-label={label}
          disabled={!active}
          value={value}
          onChange={handleChange}
          valueLabelDisplay={valueLabelDisplay}
          min={min}
          max={max}
          step={step}
          track={track}
          size="small"
        />
      }
    />
  );
};

export const CollapseHeading = (props) => {
  const { headingClass, expanded, setExpanded, headingText } = props;

  return (
    <Typography
      component="div"
      sx={headingClass}
      onClick={() => setExpanded(!expanded)}
    >
      {headingText}
      <IconButton
        sx={[expand_, expanded && expandOpen_]}
        aria-expanded={expanded}
        aria-label="show more"
        size="large"
      >
        <ExpandMoreIcon />
      </IconButton>
    </Typography>
  );
};

export const SettingColorSelector = (props) => {
  const { fillColor, label, active, labelIcon, handleNewColor } = props;
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Setting
      active={active}
      label={label}
      labelIcon={labelIcon}
      controller={
        <>
          <Button
            aria-label={label}
            disabled={!active}
            variant="contained"
            style={
              active
                ? {
                    backgroundColor: fillColor,
                    borderWidth: 5,
                    borderStyle: "solid",
                    borderColor: "#e0e0e0",
                    padding: "10px",
                    width: 40,
                    height: 40,
                  }
                : {
                    width: 40,
                    height: 40,
                  }
            }
            onClick={(e) => setAnchorEl(e.currentTarget)}
          >
            {""}
          </Button>
          <Popover
            open={!!anchorEl}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "center",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "center",
              horizontal: "left",
            }}
          >
            <SwatchesPicker
              color={fillColor}
              onChangeComplete={(color) => {
                handleNewColor(color);
              }}
            />
          </Popover>
        </>
      }
    />
  );
};

export const SettingDropSelector = (props) => {
  const {
    active,
    label,
    labelIcon,
    formControlClass,
    value,
    handleSelection,
    optionsArray,
    defaultOption,
    fullWidth = true,
  } = props;

  const handleChange = (event) => {
    handleSelection(event.target.value);
  };

  return (
    <Setting
      active={active}
      label={label}
      labelIcon={labelIcon}
      controller={
        <FormControl
          variant="standard"
          disabled={!active}
          sx={formControlClass}
          fullWidth={fullWidth}
        >
          <Select
            MenuProps={{
              slotProps: {
                list: {
                  "aria-label": label,
                },
              },
            }}
            variant="standard"
            id="select-layer-text"
            aria-label={label}
            value={value}
            onChange={handleChange}
            displayEmpty
          >
            <MenuItem
              value={defaultOption.value}
              disabled={defaultOption.disabled}
            >
              {defaultOption.label}
            </MenuItem>
            {optionsArray.map((option, i) => {
              return (
                <MenuItem key={i} value={option.value}>
                  {option.label}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      }
    />
  );
};
